import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-74e3603c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "reaction-intro"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"reaction-intro__copy\" data-v-74e3603c><p class=\"reaction-eyebrow\" data-v-74e3603c>数字图形反应</p><h1 data-v-74e3603c>看数字，点图形</h1><p class=\"reaction-lead\" data-v-74e3603c>根据每题显示的对应关系作答。正式测试共 300 题，限时 5 分钟。</p><ol class=\"reaction-rules\" data-v-74e3603c><li data-v-74e3603c>每题的对应关系和选项位置都会变化。</li><li data-v-74e3603c>题目显示一个数字，请点击它在本题对应的图形。</li><li data-v-74e3603c>点击后立即进入下一题，不能返回修改。</li></ol><div class=\"reaction-facts\" aria-label=\"测试信息\" data-v-74e3603c><div data-v-74e3603c><strong data-v-74e3603c>300</strong><span data-v-74e3603c>题目数量</span></div><div data-v-74e3603c><strong data-v-74e3603c>05:00</strong><span data-v-74e3603c>答题时长</span></div><div data-v-74e3603c><strong data-v-74e3603c>3</strong><span data-v-74e3603c>示例题数</span></div></div></div>", 1);
const _hoisted_3 = {
  class: "reaction-intro__practice"
};
const _hoisted_4 = {
  class: "demo-prompt"
};
const _hoisted_5 = {
  class: "demo-options"
};
const _hoisted_6 = ["disabled", "onClick"];
const _hoisted_7 = {
  class: "sr-only"
};
const _hoisted_8 = {
  class: "demo-feedback",
  "aria-live": "polite"
};
const _hoisted_9 = {
  key: 1,
  class: "countdown-panel",
  "aria-live": "assertive"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "准备开始", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "保持注意力集中", -1));
const _hoisted_12 = {
  key: 2,
  class: "reaction-exam"
};
const _hoisted_13 = {
  class: "reaction-status"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "status-label"
}, "进度", -1));
const _hoisted_15 = {
  class: "status-time"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "status-label"
}, "剩余时间", -1));
const _hoisted_17 = {
  class: "reaction-progress"
};
const _hoisted_18 = ["aria-busy"];
const _hoisted_19 = {
  key: 0,
  class: "reaction-question"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请点击数字对应的图形", -1));
const _hoisted_21 = {
  class: "target-digit"
};
const _hoisted_22 = {
  class: "reaction-options"
};
const _hoisted_23 = ["disabled", "onClick", "aria-label"];
const _hoisted_24 = {
  key: 1,
  class: "saving-state"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "saving-spinner",
  "aria-hidden": "true"
}, null, -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "正在保存作答记录", -1));
const _hoisted_27 = {
  key: 3,
  class: "reaction-result"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "reaction-eyebrow"
}, "测试完成", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "本次作答已保存", -1));
const _hoisted_30 = {
  class: "result-grid"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "答对", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "答错", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "未答", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "反应中位数", -1));
const _hoisted_35 = {
  class: "result-note"
};
const _hoisted_36 = {
  key: 0,
  class: "result-warning"
};
const _hoisted_37 = {
  class: "result-actions"
};
const _hoisted_38 = {
  key: 4,
  class: "reaction-error",
  role: "alert"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "暂时无法继续", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MappingLegend = _resolveComponent("MappingLegend");
  const _component_DigitSymbolShape = _resolveComponent("DigitSymbolShape");
  return _openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["reaction-shell", `reaction-shell--${$data.phase}`])
  }, [$data.phase === 'intro' || $data.phase === 'demo' ? (_openBlock(), _createElementBlock("section", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("h2", null, _toDisplayString($data.phase === 'demo' ? `示例 ${$data.demoIndex + 1} / 3` : '对应关系'), 1), _createVNode(_component_MappingLegend, {
    mapping: $data.phase === 'demo' ? $options.demoQuestion.mapping : $data.workingSession.mapping,
    compact: ""
  }, null, 8, ["mapping"]), $data.phase === 'demo' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("p", _hoisted_4, [_createTextVNode("数字 "), _createElementVNode("strong", null, _toDisplayString($options.demoQuestion.targetDigit), 1), _createTextVNode(" 对应哪个图形？")]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.demoQuestion.optionShapeIds, (shape, index) => {
    return _openBlock(), _createElementBlock("button", {
      key: shape,
      type: "button",
      class: _normalizeClass($options.demoOptionClass(shape)),
      disabled: $data.demoLocked,
      onClick: $event => $options.answerDemo(shape)
    }, [_createVNode(_component_DigitSymbolShape, {
      "shape-id": shape,
      size: 52
    }, null, 8, ["shape-id"]), _createElementVNode("span", _hoisted_7, "选项 " + _toDisplayString(index + 1), 1)], 10, _hoisted_6);
  }), 128))]), _createElementVNode("p", _hoisted_8, _toDisplayString($data.demoFeedback), 1)], 64)) : (_openBlock(), _createElementBlock("button", {
    key: 1,
    class: "primary-action",
    type: "button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.startDemo && $options.startDemo(...args))
  }, "开始示例"))])])) : $data.phase === 'countdown' ? (_openBlock(), _createElementBlock("section", _hoisted_9, [_hoisted_10, _createElementVNode("strong", null, _toDisplayString($data.countdown), 1), _hoisted_11])) : $data.phase === 'active' || $data.phase === 'finishing' ? (_openBlock(), _createElementBlock("section", _hoisted_12, [_createElementVNode("header", _hoisted_13, [_createElementVNode("div", null, [_hoisted_14, _createElementVNode("strong", null, _toDisplayString($data.currentIndex + 1) + " / " + _toDisplayString($data.workingSession.total), 1)]), _createElementVNode("div", {
    class: _normalizeClass(["status-center", {
      'is-syncing': $data.syncing || $data.pendingEvents.length
    }])
  }, _toDisplayString($options.syncLabel), 3), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("strong", null, _toDisplayString($options.formattedRemaining), 1)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("span", {
    style: _normalizeStyle({
      width: $options.progressPercent + '%'
    })
  }, null, 4)]), _createElementVNode("div", {
    class: "reaction-workspace",
    "aria-busy": $data.phase === 'finishing'
  }, [_createVNode(_component_MappingLegend, {
    mapping: $options.currentQuestion?.mapping || []
  }, null, 8, ["mapping"]), $options.currentQuestion && $data.phase === 'active' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, _toDisplayString($options.currentQuestion.targetDigit), 1), _createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.currentQuestion.optionShapeIds, (shape, index) => {
    return _openBlock(), _createElementBlock("button", {
      key: `${$data.currentIndex}-${shape}`,
      type: "button",
      disabled: $data.answerLocked,
      onClick: $event => $options.answer(index),
      "aria-label": `选项 ${index + 1}`
    }, [_createVNode(_component_DigitSymbolShape, {
      "shape-id": shape,
      size: 72
    }, null, 8, ["shape-id"])], 8, _hoisted_23);
  }), 128))])])) : (_openBlock(), _createElementBlock("div", _hoisted_24, [_hoisted_25, _hoisted_26, _createElementVNode("p", null, _toDisplayString($data.finishMessage), 1)]))], 8, _hoisted_18)])) : $data.phase === 'result' ? (_openBlock(), _createElementBlock("section", _hoisted_27, [_hoisted_28, _hoisted_29, _createElementVNode("div", _hoisted_30, [_createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString($data.summary.correct || 0), 1), _hoisted_31]), _createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString($data.summary.wrong || 0), 1), _hoisted_32]), _createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString($data.summary.unanswered || 0), 1), _hoisted_33]), _createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString($data.summary.medianReactionTimeMs || 0) + " ms", 1), _hoisted_34])]), _createElementVNode("p", _hoisted_35, "校正分 " + _toDisplayString($data.summary.adjustedScore || 0) + "，正确率 " + _toDisplayString($data.summary.accuracy || 0) + "%", 1), $data.unsavedCount ? (_openBlock(), _createElementBlock("p", _hoisted_36, "有 " + _toDisplayString($data.unsavedCount) + " 题未能在截止时间内同步，已按未答处理。", 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_37, [_createElementVNode("button", {
    class: "secondary-action",
    type: "button",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('/'))
  }, "返回首页"), _createElementVNode("button", {
    class: "primary-action",
    type: "button",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.review && $options.review(...args))
  }, "查看详情")])])) : (_openBlock(), _createElementBlock("section", _hoisted_38, [_hoisted_39, _createElementVNode("p", null, _toDisplayString($data.errorMessage), 1), _createElementVNode("button", {
    class: "primary-action",
    type: "button",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.retry && $options.retry(...args))
  }, "重试")]))], 2);
}